import React, { forwardRef } from 'react';
import { useTooltip, useGlobalState } from '../../hooks';

import './Pill.css';

const _Pill = (
  {
    label,
    values, // Object with properties. If supplied, the "label" prop will be used as key. Can also be a string, then this will be used as key to access values from useGlobalState.
    className,
    tooltip,
  },
  ref
) => {
  const referenceValues = useGlobalState(typeof values === 'string' ? values : undefined);
  values = typeof values === 'string' ? referenceValues[0] : values;

  const { showTooltip, hideTooltip } = useTooltip();

  const value = label;

  // Use values if provided
  label = values ? values[value]?.label : label;
  tooltip = values ? values[value]?.tooltip : tooltip;
  className = values ? values[value]?.className : className;

  // Unknown status
  // Might happen in the changelog when a status has been deleted
  if (values && !values[value]) {
    label = 'Unknown';
    tooltip = 'Unknown status of this asset';
    className = 'pill-grey';
  }

  return (
    <span
      className={'pill' + (className ? ' ' + className : '')}
      ref={ref}
      onMouseEnter={() => showTooltip({ title: label, bodyText: tooltip })}
      onMouseLeave={() => hideTooltip()}
    >
      {label}
    </span>
  );
};

export const Pill = forwardRef(_Pill);
